<div class="page">
    <div #viewer class="viewer"></div>
</div>
